// TODO: move this somewhere less global
(function($) {
    $("select.form-control")
        .not("[data-no-chosen]")
        .chosen();
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./core/js/forms.js
// module id = 136
// module chunks = 3